import { RouteConfig } from 'vue-router';
import ShowTermsAndPrivacy from '@/views/registration/pages/ShowTermsAndPrivacy.vue';
import useI18n from '@/mixins/useI18n';
import Registration from '../pages/Registration.vue';
import Verification from '../pages/Verification.vue';
import Mobilephone from '../pages/Mobilephone.vue';
import VerifyMobilephone from '../pages/VerifyMobilephone.vue';
import RegistrationFinished from '../pages/RegistrationFinished.vue';

const { t } = useI18n();

const routes: Array<RouteConfig> = [
  {
    path: '/register',
    name: 'register',
    component: Registration,
    meta: {
      layout: 'login-register',
      title: t('landingpage.title_register_freelancer'),
      description: t('landingpage.meta_register_freelancer'),
      robots: 'noindex, follow',
    },
  },
  {
    path: '/register-customer',
    name: 'register-customer',
    component: Registration,
    meta: {
      layout: 'login-register',
      title: t('landingpage.title_register_customer'),
      description: t('landingpage.meta_register_customer'),
      robots: 'noindex, follow',
    },
  },
  {
    path: '/register-guest/:inviteId'
      + '',
    name: 'register-guest',
    component: Registration,
    meta: {
      layout: 'login-register',
      title: t('landingpage.title_register_guest'),
      description: t('landingpage.meta_register_guest'),
      robots: 'noindex, follow',
    },
  },
  {
    path: '/register/verify',
    name: 'register-verify',
    component: Verification,
    meta: {
      layout: 'login-register',
      robots: 'noindex, follow',
    },
  },
  {
    path: '/register/mobile',
    name: 'register-mobilephone',
    component: Mobilephone,
    meta: {
      layout: 'login-register',
      robots: 'noindex, follow',
    },
  },
  {
    path: '/register/mobile/verify',
    name: 'register-mobilephone-verify',
    component: VerifyMobilephone,
    meta: {
      layout: 'login-register',
      robots: 'noindex, follow',
    },
  },
  {
    path: '/register/finished',
    name: 'register-finished',
    component: RegistrationFinished,
    meta: {
      layout: 'login-register',
      robots: 'noindex, follow',
    },
  },
  {
    path: '/@show-terms',
    name: 'show-terms',
    component: ShowTermsAndPrivacy,
    meta: {
      layout: 'plain',
      robots: 'noindex, follow',
    }
  },
  {
    path: '/@show-privacy',
    name: 'show-privacy',
    component: ShowTermsAndPrivacy,
    meta: {
      layout: 'plain',
      robots: 'noindex, follow',
    }
  }
];

export default routes;
